import { takeEvery, all, call, put } from 'redux-saga/effects';
import apiService from 'app/bff/services/apiService';
import { SystemParamIdEnum, SystemParamTypesEnum, SystemOptionTypesEnum } from 'app/bff/enums/system';
import { LinkPositionEnum } from 'app/bff/enums/link';
import { CountriesIdEnum } from 'app/bff/enums/country';
import { DataResp } from 'app/bff/models/info/infoGetnationlist';
import { MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';
import commonService from 'app/core/services/commonService';
import { sagaBoundary } from 'app/store/service';
import { CommonState, COMMON__INIT_FETCH_COMMON_DATA, COMMON__FETCH_MEMBER_PROFILE, FetchMemberProfileAction } from './types';
import { initFetchCommonDataDoneAction, fetchMemberProfileDoneAction } from './actions';

/**
 * @description 初始取得系統共用選項資料
 */
function * initFetchCommonData () {
  const response: CommonState = yield all({
    systemParameters: call(apiService.postInfoSysparams, { paramType: SystemParamTypesEnum.All }),
    systemOptions: call(apiService.postInfoSysopts, { optSid: [SystemOptionTypesEnum.All] }),
    systemMessages: call(apiService.postInfoGetmsgtext, { msgType: null, msgId: [] }),
    postcodes: call(apiService.postInfoAddressGetcityarea),
    getnationList: call(apiService.postInfoGetnationlist, {}),
    bankList: call(apiService.postInfoBanklist, {}),
    links: call(apiService.postInfoGetlinkUrl, { page: [LinkPositionEnum.ExtraDoc] }),
    baseUrls: call(apiService.postInfoSysparams, { paramType: SystemParamTypesEnum.BaseURL, paramId: SystemParamIdEnum.DocURL }),
    jobs: call(apiService.postInfoGetJobs)
  });
  const countries = response.getnationList.reduce((acc: DataResp[], curr) => acc.concat(curr.data), []);
  const nativeCountry = countries.find((country) => country.countryId === CountriesIdEnum.TW) ?? null;
  const foreignCountries = countries.filter((country) => country.countryId !== CountriesIdEnum.TW);
  const relationshipPrecedenceOptions = response.systemOptions.filter((param) => param.optSid === SystemOptionTypesEnum.BfcRelationPrec);
  const relationshipProportionOptions = response.systemOptions.filter((param) => param.optSid === SystemOptionTypesEnum.BfcRelationProp);
  const relationshipPrecedenceU7Options = response.systemOptions.filter((param) => param.optSid === SystemOptionTypesEnum.BfcRelationPrecU7);
  const relationshipProportionU7Options = response.systemOptions.filter((param) => param.optSid === SystemOptionTypesEnum.BfcRelationPropU7);
  const combineResponse = { ...response, countries, nativeCountry, foreignCountries, relationshipPrecedenceOptions, relationshipProportionOptions, relationshipPrecedenceU7Options, relationshipProportionU7Options };
  yield put(initFetchCommonDataDoneAction(combineResponse));
}

/**
 * @description 取得會員資料
 */
function * fetchMemberProfile (action: FetchMemberProfileAction) {
  const response: MbGetinfoResp = yield call(apiService.postMbGetinfo, action.payload.args);
  if (response) {
    const decryptedMemberInfo = commonService.decryptMemberInfo(response);
    yield put(fetchMemberProfileDoneAction(decryptedMemberInfo));
  }
}

export default function * watchCommonSaga () {
  yield all([
    takeEvery(COMMON__INIT_FETCH_COMMON_DATA, sagaBoundary(initFetchCommonData)),
    takeEvery(COMMON__FETCH_MEMBER_PROFILE, sagaBoundary(fetchMemberProfile))
  ]);
}
